export const playerStatKeys = {
	playerStats: (organizationUuid: string, teamLeagueUuid: string, seasonUuid: string, playerUuid: string) =>
		[`PLAYER_STATS`, organizationUuid, teamLeagueUuid, seasonUuid, playerUuid] as const,
	playerAvailability: (organizationUuid: string, teamLeagueUuid: string, playerUuid: string) =>
		[`PLAYER_AVAILABILITY`, organizationUuid, teamLeagueUuid, playerUuid] as const,
	players: (organizationUuid: string, teamLeagueUuid: string, serializedSearchParams: string) =>
		['PLAYERS', organizationUuid, teamLeagueUuid, serializedSearchParams] as const
};
